import React from 'react'

const FooterContainer = () => (
  <footer id="footer" className="footer admin-footer">
    <div className="container">
      <p className="text-muted credit my-1"></p>
    </div>
  </footer>
);

export default FooterContainer
